import React, { useRef } from 'react'
import { withAutoBlur } from '../../../utils/misc'
import { useConfigurationStore } from '@stores'
import { usePulseAnimation } from '@hooks'
import { cn } from '@amusnet/react-ui'

interface SideButtonProps {
    id: string
    isActive: boolean
    onClick: (e?: React.MouseEvent<HTMLButtonElement>) => void
    isInteractive?: boolean
    texture: string
    className?: string
    shouldUpdateOpacityWhenInactive?: boolean
    disableAutoBlur?: boolean
    pulse?: boolean
}

const SideButton: React.FC<SideButtonProps> = ({
    id,
    isActive,
    isInteractive = true,
    onClick,
    texture,
    className = '',
    shouldUpdateOpacityWhenInactive = true,
    disableAutoBlur = false,
    pulse,
}) => {
    const handleClick = disableAutoBlur ? onClick : withAutoBlur(onClick)
    const buttonRef = useRef<HTMLButtonElement>(null)
    const configStyles = useConfigurationStore((state) => state.getComponentConfig('SideButton').styles)

    usePulseAnimation({ ref: buttonRef, pulse })

    return (
        <>
            <button
                ref={buttonRef}
                id={id}
                className={cn(
                    'w-[120px] h-[120px] focus:outline-none brightness-100 rounded-full overflow-hidden',
                    configStyles,
                    className,
                    !isActive && [shouldUpdateOpacityWhenInactive && 'opacity-50', 'pointer-events-none'],
                    !isInteractive && 'pointer-events-none'
                )}
                onClick={handleClick}
            >
                <img src={texture} alt="Bet Option Button" className="w-full h-full" />
            </button>
        </>
    )
}

export default SideButton
